<template>
  <div class="">
    <div v-if="$isMobile">
      <van-action-sheet v-model="show" title="Chi tiết gói">
        <div class="content" v-if="true">
          <div class="page_pay_info_list">
            <div class="page_pay_info_img">
              <img :src="shopData.img" alt="" />
            </div>
            <div class="page_pay_info_list_text">
              <div class="page_pay_info_list_top">{{ shopData.name }}</div>
              <div class="page_pay_info_list_bottom">
                {{ shopData.price }} VND
              </div>
            </div>
          </div>
          <div class="page_dec_title">Thông tin gói nạp</div>
          <div class="page_dec" v-html="dec"></div>
        </div>
        <div v-else class="noData">Đơn hàng đang trống</div>
        <div class="model_bottom">
          <div class="model_bottom_num">
            <div class="model_bottom_num_left">Số lượng</div>
            <div class="model_bottom_num_right">x1</div>
          </div>
          <div class="model_bottom_content">
            <div class="page_bottom_left">
              <div class="page_bottom_money">
                <div class="page_bottom_money_top">Thành tiền</div>
                <div class="page_bottom_money_bottom">
                  {{ shopData.price }} VND
                </div>
              </div>
            </div>
            <div class="page_bottom_right">
              <el-button
                type="danger"
                class="page_bottom_btn"
                @click="getProductData()"
              >
                Thêm vào giỏ hàng
              </el-button>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <div v-else>
      <el-dialog
        class="el_dialog_content"
        title="Chi tiết gói"
        :visible.sync="show"
        width="30%"
        center
      >
        <div class="content" v-if="true">
          <div class="page_pay_info_list">
            <div class="page_pay_info_img">
              <img :src="shopData.img" alt="" />
            </div>
            <div class="page_pay_info_list_text">
              <div class="page_pay_info_list_top">{{ shopData.name }}</div>
              <div class="page_pay_info_list_bottom">
                {{ shopData.price }} VND
              </div>
            </div>
          </div>
          <div class="page_dec_title">Thông tin gói nạp</div>
          <div class="page_dec" v-html="dec"></div>
        </div>
        <div v-else class="noData">Đơn hàng đang trống</div>
        <div class="model_bottom">
          <div class="model_bottom_num">
            <div class="model_bottom_num_left">Số lượng</div>
            <div class="model_bottom_num_right">x1</div>
          </div>
          <div class="model_bottom_content">
            <div class="page_bottom_left">
              <div class="page_bottom_money">
                <div class="page_bottom_money_top">Thành tiền</div>
                <div class="page_bottom_money_bottom">
                  {{ shopData.price }} VND
                </div>
              </div>
            </div>
            <div class="page_bottom_right">
              <el-button
                type="danger"
                class="page_bottom_btn"
                @click="getProductData()"
              >
                Thêm vào giỏ hàng
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      show: false,
      shopData: {},
      selectedIndex: null,
      dec: "Nạp nhận<span style='color:#FF0000;'> </span><span style='font-weight:bold; color:#FF0000;'>100 Tiên Ngọc</span><br>   <span color:#000000;'>Nạp lần đầu</span> nhận thêm<span style='color:#FF0000;'> </span><span style='font-weight:bold; color:#FF0000;'>300 Nguyên Bảo</span><span style='color:#0070C0;'>.</span>   <br>   <span style='font-weight:bold'; color:#000000'>Tiên Ngọc</span> có thể dùng để mua các túi quà ingame như: <span style='font-weight:bold; color:#000000;'>Quà Nạp Đầu, Quà Ưu Đãi, Thẻ Tháng, Thẻ Tuần, Quỹ Vượt Ải, các gói quà trong hoạt động…</span><span style='color:#0070C0;'>.</span>   <br>       *Lưu ý: mua <span style='color:#FF0000;'> </span><span style='font-weight:bold; color:#000000;'>Tiên Ngọc trên Webshop không cộng điểm VIP</span>, cần dùng <span style='font-weight:bold; color:#000000;'>Tiên Ngọc mua các túi quà ingame mới có thể tăng điểm VIP.</span> <br>",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getProductData() {
      this.show = false;
      this.$parent.productData = this.shopData;
      this.$parent.handleAdd(this.shopData, this.selectedIndex);
    },
  },
};
</script>

<style scoped lang="scss">
.van-action-sheet {
  max-height: 90%;
}
.van-action-sheet__header {
  padding: 16px 0;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px;
  font-size: 1.25rem;
  font-weight: bold;
}
.content {
  padding: 16px 16px 0;
  height: 50vh;
  overflow: auto;
}
.page_pay_info_list_bottom {
  color: #f05c22;
}
.noData {
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  flex: 1 1 0%;
  overflow: auto;
  padding: 16px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  font-style: italic;
  color: rgb(137, 123, 118);
}
.model_bottom {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  padding-inline-start: 24px;
  padding-inline-end: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.05) 0px -4px 12px 0px;
}

.model_bottom_num {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  flex-flow: row;
  -webkit-box-pack: justify;
  -webkit-box-align: center;
  align-items: center;
}

.model_bottom_num_left {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}

.model_bottom_num_right {
  display: flex;
  background: #f4f2f1;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}

.model_bottom_content {
  margin-top: 16px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.page_bottom_left {
  display: flex;
  gap: 8px;
  flex-flow: row;
}

.page_bottom_money {
  display: flex;
  gap: 0px;
  flex-flow: column;
  justify-content: space-around;
}

.page_bottom_money_top {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: rgb(137, 123, 118);
}

.page_bottom_money_bottom {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #f05c22;
}

.page_dec_title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  margin-top: 9px;
}
.page_dec {
  margin: 9px 0 10vh;
  text-align: left;
  font-size: 16px;
  line-height: 20px;
}

/deep/.el-dialog__header {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px 0px;
  font-size: 1.25rem;
  font-weight: bold;
}
/deep/.el-dialog--center .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog {
  margin-top: 10vh !important;
  width: 27% !important;
  border-radius: 8px !important;
}
/deep/.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
.el_dialog_content .content {
  height: 30vh;
}
.el_dialog_content .page_dec_title {
  margin-top: 16px;
}
.el_dialog_content .page_dec {
  margin: 10px 0 0vh;
  font-size: 16px;
  line-height: 22px;
}
</style>
